import React from "react"
import {
  newsletterWrapper,
  newsletterInner,
  title,
} from "./cta-newsletter.module.css"
import HubSpotForm from "../hubspot-form/hubspot-form"

const CtaNewsletterComponent = ({
  header = "Altijd op de hoogte van het laatste ondernemersnieuws?",
  description = "Meld je aan voor onze nieuwsbrief",
  position = 0,
  backgroundColor = "#ffffff",
}) => {
  return (
    <div className={newsletterWrapper}>
      <div className={newsletterInner + " form-newsletter"} style={{ backgroundColor }}>
        <p className={title}>{header}</p>

        <p className="text">{description}</p>

        <div style={{ minHeight: "67px" }}>
          <HubSpotForm
            formId="1f0705a4-9d0f-4a81-a130-a31651b9b0a4"
            idModifier={position}
          />
        </div>
      </div>
    </div>
  )
}

export default CtaNewsletterComponent
